<template>
    <div class="transition-all border border-brand-teal-light/20 rounded-[2em] overflow-hidden bg-brand-teal-feint hover:shadow-xl" >
        <dt class="transition-colors cursor-pointer  rounded-md py-4 px-5 lg:px-10 leading-tight lg:text-lg flex justify-between items-center w-full text-left  font-semibold" @click="toggleTranscript" :id="id">
            {{ question }}
            <svg focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="w-6" :class="{'rotate-180': open}" viewBox="0 0 640 640"><path d="M331.3 475.3C325.1 481.5 314.9 481.5 308.7 475.3L100.7 267.3C94.5 261.1 94.5 250.9 100.7 244.7C106.9 238.5 117.1 238.5 123.3 244.7L320 441.4L516.7 244.7C522.9 238.5 533.1 238.5 539.3 244.7C545.5 250.9 545.5 261.1 539.3 267.3L331.3 475.3z"/></svg>
        </dt>

        <dd class="leading-relaxed lg:leading-relaxed font-light lg:text-lg text-left" :class="[ open ? 'block' : 'hidden' , 'bg-white p-6']">
            <slot></slot>
        </dd>
    </div>
</template>

<script>
    export default {
        props: {
            question: String,
            id: String,
            split: String,
        },

        data() {
            return {
                open: false
            }
        },

        methods: {
            toggleTranscript() {
                this.open = ! this.open;
            },
        }
    }
</script>

<style scoped>
.expandable {
    height: 0px;
    overflow: hidden;
    opacity: 0;
    transition: all .15s ease-in-out;
}

.expandable.is-expanded {
    height: auto;
    opacity: 1;
}
</style>
